import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import SelectTemplateTable from "./select-template-table";
import * as ScrollArea from "@radix-ui/react-scroll-area";

const SelectTemplateDialog = ({ open, onClose, onTemplateSelected }: any) => {
  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-[rgba(0,0,0,.6)] data-[state=open]:animate-overlayShow fixed inset-0" />

        <Dialog.Content
          onEscapeKeyDown={(event) => event.preventDefault()}
          className="z-50 data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[90vh] h-full w-full max-w-[90vw] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-blackLight focus:outline-none text-body"
        >
          <ScrollArea.Root className="w-full h-full overflow-hidden relative ">
            <ScrollArea.Viewport className="w-full h-full mt-4">
              <div className="space-y-4">
                <SelectTemplateTable onTemplateSelected={onTemplateSelected} />
              </div>
            </ScrollArea.Viewport>

            <ScrollArea.Scrollbar
              className="flex mt-4 select-none touch-none p-0.5 transition-colors duration-[160ms] ease-out hover:bg-black data-[orientation=vertical]:w-2.5 data-[orientation=horizontal]:flex-col data-[orientation=horizontal]:h-2.5"
              orientation="vertical"
            >
              <ScrollArea.Thumb className="flex-1 bg-scrollbarColor rounded-[10px] relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
            </ScrollArea.Scrollbar>
          </ScrollArea.Root>

          <Dialog.Close asChild>
            <button
              className="text-white hover:text-primary focus:shadow-violet7 absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
              aria-label="Close"
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default SelectTemplateDialog;
